import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { DEFAULT_BRANDING, subscribeBranding } from '../services/brandingService';

const BrandingContext = createContext({ branding: DEFAULT_BRANDING, loading: true });

export function useBranding() {
  return useContext(BrandingContext);
}

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULT_BRANDING);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = subscribeBranding(
      (data) => {
        setBranding(data);
        setLoading(false);
      },
      () => setLoading(false)
    );
    return unsubscribe;
  }, []);

  useEffect(() => {
    document.title = `${branding.productName || 'Pravah'} | ${branding.organisationName || 'Workspace'}`;
    const favicon = document.querySelector("link[rel='icon']") || document.createElement('link');
    favicon.rel = 'icon';
    favicon.href = '/brand/favicon-64.png';
    if (!favicon.parentNode) document.head.appendChild(favicon);
  }, [branding.productName, branding.organisationName]);

  const value = useMemo(() => ({ branding, loading }), [branding, loading]);
  return <BrandingContext.Provider value={value}>{children}</BrandingContext.Provider>;
}
